// Dashboard — project list and usage stats for authenticated users
import { t } from '../shared/i18n.ts';
import { authenticatedFetch, showToast } from '../shared/utils.ts';
import { isAuthenticated, clearAuthState } from '../shared/auth.ts';
import { renderDashboard, createProject } from './project-list.ts';
import { initSketchModal, openSketchModal, closeSketchModal, analyzeSketch } from './sketch-modal.ts';
import { login_path } from '../shared/routes';
import { api_v1_dashboard_path } from '../shared/api-routes';

/**
 * Fetch dashboard data from the API and render the page.
 */
export async function loadDashboard() {
  if (!isAuthenticated()) {
    window.location.href = login_path();
    return;
  }

  let resp;
  try {
    resp = await authenticatedFetch(api_v1_dashboard_path());
  } catch (err) {
    console.error('Failed to load dashboard:', err);
    showToast(t('dashboard.networkError'));
    return;
  }

  if (resp.status === 401) {
    clearAuthState();
    window.location.href = login_path();
    return;
  }

  if (!resp.ok) {
    showToast(t('dashboard.networkError'));
    return;
  }

  const data = await resp.json();
  renderDashboard(data, { reloadDashboard: loadDashboard });
}

// Re-export for external consumers
export { createProject, openSketchModal, closeSketchModal, analyzeSketch };

/**
 * Called by `entrypoints/dashboard.ts` after a single `initI18n()`.
 *
 * This module used to register its own `DOMContentLoaded` listener at import
 * time while the entrypoint registered a second one, so `initI18n()` ran
 * twice — two locale requests and two full `[data-i18n]` sweeps of the
 * document. Every other page (`initBlog`, `initBrands`, `initLanding`)
 * already exports an init function instead; this matches them.
 */
export function initDashboard(): void {
  loadDashboard();

  // Button event listeners
  const btnNew = document.getElementById('btnNewProject');
  if (btnNew) btnNew.addEventListener('click', createProject);

  const btnFirst = document.getElementById('btnFirstProject');
  if (btnFirst) btnFirst.addEventListener('click', createProject);

  // Sketch modal
  initSketchModal();
}
